// External libraries
import { css } from '@emotion/core';

// Internal modules
import {
  DEFAULT_BORDER_COLOR,
  ERROR_COLOR,
  HEADER_COLOR,
  PP_LIGHT_GRAY_COLOR,
  PP_LINK_ALT_COLOR,
} from '@/styles';
import styled from '@emotion/styled';

const selectInstallmentButtonStyleOverrides = (
  hasError = false,
  isSelected = 0,
) => css`
  background-color: #fff;
  border: 1px solid ${hasError ? ERROR_COLOR : DEFAULT_BORDER_COLOR};
  border-radius: 4px;
  font-size: 16px;
  height: 64px;
  outline: 0;
  position: relative;
  text-align: left;
  transition: background-color 0.4s ease-out 0s;
  width: 100%;

  label {
    color: ${PP_LIGHT_GRAY_COLOR};
    cursor: pointer;
    left: 13px;
    position: absolute;
    top: 10px;
    transform: none;
    /* .components/field-label-sm */
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }

  ::before {
    border-bottom: 1px solid ${HEADER_COLOR};
    border-right: 1px solid ${HEADER_COLOR};
    content: '';
    height: 10px;
    pointer-events: none;
    position: absolute;
    right: 16px;
    top: calc(${isSelected} * (34% - 2px) + (1 - ${isSelected}) * (50% - 2px));
    transform: translateY(-50%) rotate(45deg);
    width: 10px;
  }

  :active,
  :focus,
  :hover {
    background-color: #c5ccd1;
  }
`;

const TotalLabel = styled.div`
  padding-top: 10px;
`;

const ButtonValue = styled.div`
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  padding: ${({ isSelected }) =>
    isSelected ? '21px 0 0 11px' : '4px 0 0 11px'};
  color: ${({ isSelected }) =>
    isSelected ? PP_LINK_ALT_COLOR : PP_LIGHT_GRAY_COLOR};
`;

const DiscountOrFeeLabel = styled.span`
  padding-left: 5px;
`;
export {
  selectInstallmentButtonStyleOverrides,
  TotalLabel,
  ButtonValue,
  DiscountOrFeeLabel,
};
